import translator from 'src/translate'
import { withStyles } from '@material-ui/core/styles'
import React, { useState, useRef } from 'react'
import parse from 'html-react-parser'
import styles from '../styles'
import {
  Typography,
  Box,
  FormGroup,
  FormControlLabel,
  Switch,
  CircularProgress,
} from '@material-ui/core'
import { mediaImageUploadAction } from 'src/reducers/media-image/action'
import { coursePatchAction } from 'src/reducers/course/action'
import { useDispatch, useSelector } from 'react-redux'
import { useCourseSettings } from 'src/hooks/useCourseSettings'

import { AssignmentFieldNames } from 'src/model/assignment'
import { PatchContent, PatchData } from 'src/model/patch'
import TitleLogo from './components/title-logo'
import { courseSettingPatch } from 'src/reducers/course/action'
import URL from 'src/api/url/api'
import { settingsDrawerOpenSuccess } from 'src/reducers/course/action'
import { CoreButton, CoreTextField } from 'src/components/core'
const SETTING_KEY = 'seo'
const SeoSettings = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const entity = useSelector(state => state.course.course)
  const handleDrawerClose = () => {
    dispatch(settingsDrawerOpenSuccess())
  }
  const [assignmentTitle, setAssignmentTitle] = useState(entity.name)
  const [assignmentDescription, setAssignmentDescription] = useState(
    entity.description,
  )

  const [loading, setLoading] = useState(false)
  const { execute, update, exists, value } = useCourseSettings(SETTING_KEY)

  const [faviconUrl, setFaviconUrl] = useState(exists ? value.favicon : '')

  const [thumbnailUrl, setThumbnailUrl] = useState(
    exists ? value.thumbnail : '',
  )

  const [indexGoogle, setIndexGoogle] = useState(
    exists ? value.indexGoogle : false,
  )

  const [title, setTitle] = useState(entity.name)

  const onFaviconUpload = event => {
    dispatch(
      mediaImageUploadAction(event.target.files[0], '', result => {
        setFaviconUrl(`${result.url}`)
      }),
    )
  }
  const handleIndexGoogle = () => {
    setIndexGoogle(!indexGoogle)
  }

  const saveSettings = e => {
    const variables = {
      title: title,
      description: assignmentDescription,
      favicon: faviconUrl,
      thumbnail: thumbnailUrl,
      indexGoogle: indexGoogle,
    }
    setLoading(true)

    if (!exists) {
      // create a setting entity with execute function
      execute(variables, () => {
        setLoading(false)
        handleDrawerClose()
      })
    } else {
      update(variables, () => {
        setLoading(false)
        handleDrawerClose()
      })
    }
    const patchSource = new PatchData(null, entity[AssignmentFieldNames.ID])

    patchSource.addContent(
      new PatchContent(
        assignmentTitle,
        AssignmentFieldNames.NAME,
        PatchData.OPERATION_REPLACE,
      ),
    )
    patchSource.addContent(
      new PatchContent(
        assignmentDescription,
        AssignmentFieldNames.DESCRIPTION,
        PatchData.OPERATION_REPLACE,
      ),
    )
    dispatch(
      coursePatchAction(patchSource, () => {
        setLoading(false)
      }),
    )
  }
  const handleTextFieldChangeDescription = e => {
    setAssignmentDescription(e.target.value)
  }
  const handleTextFieldChange = e => {
    setAssignmentTitle(e.target.value)
  }
  return (
    <form>
      <div className={classes.content}>
        <CoreTextField
          fullWidth
          label={translator._('assignment.assignmentName')}
          defaultValue={assignmentTitle}
          placeholder={translator._('assignment.assignmentName')}
          onChange={handleTextFieldChange}
        />
        <Box m={1}></Box>
        <CoreTextField
          multiline
          maxRows={3}
          minRows={3}
          fullWidth
          defaultValue={assignmentDescription}
          placeholder="Description (for collection page & SEO)"
          label="Description (for collection page & SEO)"
          onChange={handleTextFieldChangeDescription}
        />

        <TitleLogo
          assignmentTitle={assignmentTitle}
          handleTextFieldChange={handleTextFieldChange}
          assignmentDescription={assignmentDescription}
          handleTextFieldChangeDescription={handleTextFieldChangeDescription}
        />
        {loading ? (
          <div className={classes.bottomButton}>
            <CircularProgress></CircularProgress>
          </div>
        ) : (
          <div className={classes.bottomButton}>
            <CoreButton
              fullWidth={true}
              color="success"
              size="small"
              variant="contained"
              onClick={() => saveSettings()}
            >
              {translator._('assignment.courseSettings.save')}
            </CoreButton>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }} m={1}></Box>
            <CoreButton
              fullWidth={true}
              color="success"
              size="small"
              variant="outlined"
              sx={{ display: { xs: 'block', sm: 'none' } }}
              onClick={() => handleDrawerClose()}
            >
              {translator._('assignment.courseSettings.cancel')}
            </CoreButton>
          </div>
        )}
      </div>
    </form>
  )
}

export default withStyles(styles)(SeoSettings)
